export enum CorrelationMode {
  CORRELATIONS = 'correlations',
  AVERAGED_CORRELATIONS = 'averaged-correlations',
}
